export default "__VITE_ASSET__CoZ6L1V4__"